window.header = function header() {
    return {
        showCartMenu: false,
    }
}

window.quickReplace = function quickReplace() {
    if (window.quickReplaceUri != undefined) {
        history.replaceState({}, '' , window.quickReplaceUri);
    }
}

window.quickReplace();
